<template>
  <div
    class="el-popper industry-dropdown"
    :class="{'hq-industry-dropdown':HQ}"
    :style="{ width: '275px' }"
  >
    <el-scrollbar
      tag="ul"
      ref="scrollbar"
      wrap-class="search-scroll_wrap"
    >
      <!-- @click="onSelectAll()"   @click="(initialIndustry && initialIndustry.indexOf(item.value) == -1) ? '1' :onSelect(item.value,item,index)"-->
      <ul class="clearfix">
        <li
          class="industry-item"
          @mouseover="hoverSelectAll()"
          :class="checkAll() ? 'selected' : ''"
        >全部行业
          <i
            class="el-icon-arrow-right"
            style="position: absolute;right:10px;line-height: 34px;color:555;"
          ></i>
        </li>
        <li
          v-for="(item, index) in industryOptions"
          :key='index'
          :class="[index==currentIndex && 'selected', item.count>0 && 'countCurrent','industry-item', (item.count>0 ||value.indexOf(item.value)!=-1)&&'countSelect']"
          @mouseover="onSelect(item.value,item,index)"
        >
          <!-- {{item.label}} -->
          <span
            class="industry-label-text"
            :style="{ 'max-width':(item.count>0)?('86%'):('100%')}"
          >{{item.label}}</span>
          <span
            style="margin-left:10px;"
            class="countIndex"
            v-if='item.count'
          >{{item.count}}</span>
          <i
            class="el-icon-arrow-right"
            style="position: absolute;right:10px;line-height: 34px;color:555;"
          ></i>
        </li>
      </ul>
    </el-scrollbar>
    <div class="industry-level-two">
      <el-scrollbar
        tag="ul"
        ref="scrollbar"
        wrap-class="search-scroll_wrap"
      >
        <ul>
          <!-- :class="secondList.count<=0 || secondList.industry.length<=0 ?'selected':''" -->
          <li
            class="industry-item-second"
            @click="onSelectSecondAll(secondList.value,secondList.code)"
            :class="[checkSecondAll(secondList.code)?'selected':'',(querystring&&initialIndustry&&industryshortArr.length==0|| (querystring&&industryshortArr.length>0&& industryshortArr.indexOf(secondList.code) == -1)) && 'not-allowed']"
          >全部</li>
          <li
            v-for="(item,index) in secondList.industry"
            :key='index'
            @click="onSelectSecond(item.industryCode,secondList)"
            :class="[checkSecond(item.industryCode) ? 'industry-item-second selected' : 'industry-item-second',(initialIndustry && initialIndustry.indexOf(item.industryCode) == -1) && 'not-allowed']"
          >
            <el-tooltip
              :content="item.industryName"
              placement="bottom"
              effect="dark"
              :disabled='item.industryName.length<16'
            >
              <span>{{item.industryName}}</span>
            </el-tooltip>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script >
import Popper from 'element-ui/lib/utils/vue-popper';
import { industryOptions,industrySecondClassify,industrySecondClassifyToIndustry,industryArr } from '../../common/optionMap';
export default {
  data() {
    return {
      minWidth: '',
      industryOptions: JSON.parse(JSON.stringify(industryOptions)),
      HQ: __VERSION==='HQ',
      industrySecondClassify: JSON.parse(JSON.stringify(industrySecondClassify)),
      secondList: {
        industry: [],
      },
      currentIndex: null,
      industryshortArr:[]
    };
  },
  props: ['value','querystring'],
  computed: {
    initialIndustry() {
      try {
      if(!this.querystring) return null;
      if(this.querystring.indexOf('}')!=-1) {
        let form=JSON.parse(this.querystring);
        if(!form){ return null}
        if(form.filter) {
          form.filter=JSON.parse(form.filter);
        }
        if(form.filter.industryshort.length>0||form.filter.secindustryshort.length>0) {
          if(form.filter.industryshort.length>0) {
            let industryshortArr=[]
            for(let index=0;index<form.filter.industryshort.length;index++) {
              const element=this.industrySecondClassify[form.filter.industryshort[index]-1];
              let codeArr=element.industry.map((item) => { return item.industryCode })
              industryshortArr=[...industryshortArr,...codeArr]
              this.industryshortArr.push(element.code)
            }
            return [...industryshortArr,...form.filter.secindustryshort];

          } else {
            return [...form.filter.secindustryshort];
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
            } catch (error) {
        return null;

      }
    }
  },
  watch: {},

  methods: {
    onSelect(val,item,classIndex) {
      let options=this.value.slice()
      const index=options.indexOf(val)
      this.industrySecondClassify.forEach((item,index) => {
        if(item.code==val) {
          this.secondList=item
        }
      })
      this.currentIndex=classIndex
    },
    hoverSelectAll() {
      this.currentIndex=null;
      this.secondList={
        industry: [],
      }
    },
    onSelectAll() {
      this.$emit('input',[]);
      this.secondList={
        industry: [],
      }
      this.currentIndex=null;
      this.industrySecondClassify.forEach(element => {
        element.count=0
        this.industryOptions.forEach((items,index) => {
          if(items.value==element.code) {
            items['count']=element.count
          }
        })
      });
      this.checkSecondAll('')
    },
    checkAll() {
      // if (this.value.length === 0) {
      //   return true;
      // }
      if(this.currentIndex===null) {
        return true
      }
    },
    check(val) {
      // if (this.value.indexOf(val) != -1) {
      //   return true;
      // }
    },
    //二级行业
    onSelectSecondAll(val,code) {
      if((this.querystring&&this.initialIndustry&&this.industryshortArr.length==0)||(this.querystring&&this.industryshortArr.length>0&&this.industryshortArr.indexOf(code)==-1)) {
        return
      }
      if(!val&&!code) {
        this.onSelectAll()
        return
      }
      const index=this.value.indexOf(code)
      this.industrySecondClassify.forEach(element => {
        if(element.code==code) {
          element.industry.forEach((item) => {
            if(this.value.indexOf(item.industryCode)!=-1) {
              this.value.splice(this.value.indexOf(item.industryCode),1)
              if(element.count>0) {
                element.count--;
              }
            }
          })
          this.industryOptions.forEach((items,index) => {
            if(items.value==element.code) {
              items['count']=element.count
            }
          })
        }
      });
      if(index!=-1) {
        this.value.splice(index,1)
      } else {
        this.value.push(code)
      }
      let clearIndex=this.value.indexOf('clear')
      if(clearIndex!=-1) {
        this.value.splice(clearIndex,1)
      }
      this.$emit('input',this.value);
    },
    onSelectSecond(val,item) {
      if(this.initialIndustry&&this.initialIndustry.indexOf(val)==-1) {
        return
      }
      let options=this.value.slice()
      const index=options.indexOf(val)
      if(item.industry.length==1) {
        let codeIndex=options.indexOf(item.code)
        if(codeIndex!=-1) {
          options.splice(codeIndex,1)
          item.count=0
        } else {
          options.push(item.code)
        }
      } else {
        if(index!=-1) {
          options.splice(index,1)
          item.count--;
        } else {
          options.push(val)
          item.count++;
          let codeIndex=options.indexOf(item.code)
          if(codeIndex!=-1) {
            options.splice(codeIndex,1)
          }
          if(item.industry.length==item.count) {
            item.count=0;
            this.onSelectSecondAll(item.value,item.code)
            if(this.value.indexOf(item.code)!=-1) {
              return true;
            }
          }
        }
      }
      this.industryOptions.forEach((items,index) => {
        if(items.value==item.code) {
          items['count']=item.count
        }
      })
      let clearIndex=options.indexOf('clear')
      if(clearIndex!=-1) {
        options.splice(clearIndex,1)
      }
      this.$emit('input',options)
    },
    checkSecondAll(code) {
      // if(this.secondList.industry && this.secondList.industry.length == 0) {
      //   return true
      // }
      if(this.value.indexOf(code)!=-1||(this.value.length==0&&!code)) {
        return true;
      }
    },
    checkSecond(val) {
      if(this.value.indexOf(val)!=-1) {
        return true
      }
    },
    onInitIndustry(initValue,clear=false) {
      this.industryOptions.forEach(item => { item.count=0 })
      this.industrySecondClassify.forEach(item => { item.count=0 })
      for(let index=0;index<initValue.length;index++) {
        const element=initValue[index];
        for(const key in industrySecondClassifyToIndustry) {
          if(industrySecondClassifyToIndustry.hasOwnProperty(key)) {
            const elementSub=industrySecondClassifyToIndustry[key];
            let classIndex=industryArr.indexOf(key)
            let classIndexSub=elementSub.indexOf(element)
            if(classIndexSub>-1) {
              this.industryOptions[classIndex].count+=1
              this.industrySecondClassify[classIndex].count+=1
            }
          }
        }
      }
      if(clear) {
        this.$emit('input',['clear',...initValue])
      }
    }
  },

  mounted() {
    // 根据二级行业得到一级行业
    if(this.value.length>0) {
      this.onInitIndustry(this.value)
    }
  }
};
</script>
<style lang="scss" scoped>
.industry-dropdown {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 10px 0; //10px
  background-color: #f5f7fa;
  box-shadow: -5px 0px 5px 0 rgba(0, 0, 0, 0.1);
}
.hq-industry-dropdown {
  .industry-item {
    &.selected {
      color: #337ab7;
    }
  }
}
.industry-item.countSelect {
  color: var(--theme-color);
  background-color: #f5f7fa;
  i {
    color: var(--text-content-color);
  }
}
.industry-item,
.industry-item-second {
  font-size: 14px;
  padding: 0 20px;
  position: relative;
  color: #5a5e66;
  height: 34px;
  line-height: 34px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  cursor: pointer;
}
.industry-item-second {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &.not-allowed {
    cursor: not-allowed;
    color: #999;
  }
}
.industry-label-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: top;
}
.industry-item.selected,
.industry-item-second.selected {
  // color: #46c8c8;
  background-color: #fff;
  i {
    transition: opacity 100ms ease;
    opacity: 0;
  }
}
.industry-item.selected.countCurrent,
.industry-item-second.selected {
  color: var(--theme-color);
  i {
    color: var(--text-content-color);
  }
}
// .industry-item:not(.not-allowed).hover,
// .industry-item:not(.not-allowed):hover {
//   background: #f5f7fa;
// }

.industry-item {
  float: left;
  // width: 50%;
  width: 100%;
  &.not-allowed {
    cursor: not-allowed;
    color: #999;
  }
}
.industry-level-two {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: absolute;
  left: 100%;
  top: 0;
  box-shadow: 5px 0px 5px 0 rgba(0, 0, 0, 0.1);
  padding: 10px;
  li {
    width: 100%;
    font-size: 14px;
  }
}
.search-scroll_wrap {
  height: 386px; //386
}
</style>




// WEBPACK FOOTER //
// src/components/clickSelect/industry.vue